import Vue from 'vue';

const state = {
    modal: {
        show: false,
        template: null,
        callback: null, // function - this is used as a call back for when the modal is closed, we might whant to open a second modal inside a first modal, and when the second is closed, the first one opens "automatically"
    },


    modalComponent: null,

    modalConfirmData: {
        title:'Are you sure?',
        message: 'You did something, are you sure you whant to continue? This cannot be reversed.',
        buttons:[
            {
                text:'Yes',
                class:'btn success px-5',
                action: function(){
                    console.log('Yes button pressed')
                }
            },
            {
                text:'No',
                class:'btn tertiary px-5',
                action: function(){
                    console.log('No button pressed')
                }
            }
        ]
    },

    //new multi modal system
    modalsArray:[],
};

const getters = {
    getModal: (state) => state.modal,
    getModalConfirmData: (state) => state.modalConfirmData,
    getModalComponent: (state) => state.modalComponent,
    //new multi modal system
    getModalArray: (state) => state.modalsArray,
};

const actions = {
    openModal: ({ commit }, template) => {
        // If template is just text we open the asked modal
        if(typeof template === 'string'){
            // New multi modal system
            commit('ADD_MODAL_TO_ARRAY', template)
        } else if(typeof template === 'object'){
            // If is an object we use it to provide more options
            commit('ADD_MODAL_TO_ARRAY', template.name)
            commit('CLOSE_MODAL_CALLBACK', template.callback)
        }
    },

    openModalDirect: ({ commit }, payload) => {
        // to use this the payload needs to be a component that inside has a "modal" component
        // unlike the "openModal" action this can open a modal that is outside @/tools/modal/...

        commit('ADD_MODAL_TO_ARRAY_OUTSIDE_MODAL', payload)
    },

    openComponentModal: ({commit}, component) => {
        state.modalComponent = component
        commit('ADD_MODAL_TO_ARRAY', 'ComponentModal');
        // If you want to have a title on "ComponentModal" just create a key called "modalTitle" on the component (see example "createScheduleTask"
        // Select footer for the modal:
        // data().footerType: cancelSave
        // special mehtods:
        // modalSave, modalCancel
    },

    closeModal: ({ commit, state }, payload) => {
        //new multi modal system
        // commit('CLOSE_MODAL');
        commit('REMOVE_MODAL_FROM_ARRAY')

        if(state.modal.callback){
            // console.log('closeModal @ store | payload: ', payload);
            state.modal.callback(payload);
            state.modal.callback = null;
        }
    },

    openNewMessageModal: ({ commit }, type) => {
        if (type === 'agent') {
            commit('ADD_MODAL_TO_ARRAY', 'AgentNewMessage');
        }
    },

    setModalConfirmData: ({commit, dispatch}, data) => {
        commit('SET_MODAL_CONFIRM_DATA', data);
    },

    closeAllModals: ({ commit }) => {
        commit('REMOVE_ALL_MODALS_FROM_ARRAY');
    },
};

const mutations = {
    TOGGLE_MODAL: (state) => {
        state.modal.show = !state.modal.show;
    },

    OPEN_MODAL: (state, template) => {
        state.modal.template = template;
        state.modal.show = true;
    },

    CLOSE_MODAL_CALLBACK: (state, callback) => {
        state.modal.callback = callback
    },

    CLOSE_MODAL: (state) => {
        state.modal.template = null;
        state.modal.show = false;
    },

    SET_MODAL_CONFIRM_DATA: (state, data) =>{
        state.modalConfirmData = data;
    },

    //new multi modal system

    ADD_MODAL_TO_ARRAY: (state, template) => {
        let isAlreadyOpened = false
        //need to check if modal to open(template) is already in array if so dont open it again
        state.modalsArray.forEach(modal => {
            if(modal.template === template){
                isAlreadyOpened= true
            }
        });
        if(!isAlreadyOpened){
            state.modalsArray.push({
                template: template,
                show: true, // maybe not needed
                templateImport: require(`../../tools/modal/${template}`)

            })
        }

    },

    ADD_MODAL_TO_ARRAY_OUTSIDE_MODAL: (state, payload) => {
        state.modalsArray.push({
            template: payload.name,
            show: true, // maybe not needed
            templateImport: payload.component

        })
    },

    REMOVE_MODAL_FROM_ARRAY: (state, modal) => {
        // If we have a specif modal to close we close that one,
        // Else we close te top one

        if(modal){

            let modalIndex = state.modalsArray.indexOf(modal)

            if(modalIndex > -1){
                state.modalsArray.splice(modalIndex, 1)
            }
        } else {
            if(state.modalsArray.length > 0){
                state.modalsArray.pop()
            }
        }
    },

    REMOVE_ALL_MODALS_FROM_ARRAY: (state) => {
        state.modalsArray = [];
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js